import { useMemo, useState } from 'react'
import debounce from 'lodash/debounce'

import { useGradeEdit } from '../hooks'

export const useGPTGradeEdit = () => {
  const gradeEdit = useGradeEdit(true)

  const [search, setSearch] = useState('')

  const debouncedSearch = useMemo(() => debounce(gradeEdit.search, 500), [])

  const handleSearch = (value: string) => {
    setSearch(value)
    if (!value) {
      gradeEdit.search()
      return
    }

    debouncedSearch(undefined, value)
  }

  const trainingData = gradeEdit.trainingData

  return {
    ...gradeEdit,
    search,
    handleSearch,
    trainingData,
  }
}
